import React, { FC, useCallback } from 'react';

import useScopedDispatch, { DispatchAction } from '../../../hooks/useScopedDispatch';
import PrimaryButton, { PrimaryButtonProps } from '../PrimaryButton';

export interface PrimaryActionButtonProps extends PrimaryButtonProps {
  /** The path the action to execute on click */
  onClickAction: string;
  /** A list of additional arguments to pass to the action */
  onClickArgs?: any[] | (() => any[]);
}

/**
 * @since 0.19.0
 * @mode developer
 */
const PrimaryActionButton: FC<PrimaryActionButtonProps> = ({ onClickAction, onClickArgs, ...props }) => {
  const action = useScopedDispatch(onClickAction);
  const handleClick = useCallback(() => {
    const args = ((typeof onClickArgs === 'function') ? onClickArgs() : onClickArgs);
    const argList: unknown[] = args || [];
    return (action as DispatchAction)(...argList);
  }, [action, onClickArgs]);

  return (
    <PrimaryButton
      data-testid="PrimaryActionButton"
      {...props}
      onClick={handleClick}
    />
  );
};

export default PrimaryActionButton;
